// extracted by mini-css-extract-plugin
export default {"title":"styles_title__f0P2n","title-itemized":"styles_title-itemized__esrky"};